import { render } from "./WhatHappening.vue?vue&type=template&id=19b20ed1"
import script from "./WhatHappening.vue?vue&type=script&lang=js"
export * from "./WhatHappening.vue?vue&type=script&lang=js"

import "./WhatHappening.vue?vue&type=style&index=0&id=19b20ed1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__